module.exports = __webpack_public_path__ + "img/5.7b12263e.png";